<template>
  <div>
    <div class="mb-1">
      <strong>{{ $t('message.no_datetime_booking.select_service_location') }}</strong>
    </div>
    <section v-if="userPlaces.length > 0">
      <div v-for="userPlace in userPlaces">
        <div class="card">
          <div class="card-body text-left">
            <div class="text-sm">
              <strong>{{ userPlace.place_name }}</strong>
            </div>
            <div class="text-secondary text-sm mt-1">
              {{ userPlace.address }}
              <span v-if="userPlace.sub_district">{{ userPlace.sub_district | multiLangName }}</span>
              {{ userPlace.district | multiLangName }}
              {{ userPlace.address_province | multiLangName }}
              <span v-if="userPlace.sub_district">{{ userPlace.sub_district.zip_code }}</span>
            </div>
          </div>
          <div class="d-flex justify-content-end pr-3 pb-3">
            <div>
              <button class="btn btn-info px-3" @click="selectUserPlace(userPlace)">
                {{ $t('message.company_address.choose') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-3" v-if="canLoadMore">
        <button class="btn btn-outline-info btn-block" @click="loadMoreUserPlaces()" :disabled="isLoading">
          {{ isLoading ? $t('message.button.loading') : $t('message.button.load_more') }}
        </button>
      </div>
    </section>
    <section class="text-center" v-else>
      <div v-if="isLoading">
        <loader></loader>
      </div>
      <div v-else>
        {{ $t('message.professional.no_service_provider') }}
      </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Loader from '../../loader/Loader'
  import ProfessionalPicture from '../../professional/components/ProfessionalPicture'
  import axios from 'axios'

  export default {
    props: {
      order: Object
    },
    components: {
      Loader,
      ProfessionalPicture
    },
    data () {
      return {
        page: 0,
        limit: 10,
        userPlaces: [],
        isLoading: false,
        canLoadMore: true
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      init () {
        if (!this.userPlaces.length) {
          this.page = 0
          this.userPlaces = []
          this.fetchUserPlaces()
        }
      },
      firstName (name) {
        return this.$options.filters.firstName(name)
      },
      async fetchUserPlaces () {
        this.isLoading = true
        if (this.page === 0) {
          this.userPlaces = []
        } else {
          const lastIndex = this.userPlaces.length - 1
          if (this.userPlaces[lastIndex] === null) {
            this.userPlaces.pop()
          }
        }
        const url = `/users-places`
        const params = {
          user_id: this.user.id,
          province_id: this.order.province_id,
          page: this.page,
          limit: this.limit
        }
        const {data} = await axios.get(url, {params})
        this.isLoading = false
        if (!data.error) {
          this.canLoadMore = data.user_places.length === this.limit
          if (this.page === 0) {
            this.userPlaces = data.user_places
          } else {
            this.userPlaces = this.userPlaces.concat(data.user_places)
          }
        }
      },
      loadMoreUserPlaces () {
        this.page += 1
        this.fetchUserPlaces()
      },
      selectUserPlace (userPlace) {
        this.$emit('onSelected', userPlace)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/order/components/SelectUserPlace.vue